module.exports = __webpack_public_path__ + "static/img/detect06.515bda4.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect06.png
// module id = 580
// module chunks = 4